<template>
  <ul v-if="totalPages > 1" class="pg-select">
    <li :class="{'pg-disabled': currentPage <= 1}" class="pg-index">
      <span @click="goPrev()">〈</span>
    </li>
    <li v-for="page in pages" :key="page.index">
      <span v-if="page===0" class="pg-disabled">...</span>
      <span v-else class="pg-index"
          :class="{'pg-selected': page.index==currentPage}">
        <span @click="$emit('goPage', page.index, 'index')">
          {{page.index}}
        </span>
      </span>
    </li>
    <li class="pg-index" :class="{'pg-disabled': currentPage >= totalPages}">
      <span @click="goNext()">〉</span>
    </li>
  </ul>
</template>

<script>

/*
EVENTS:
 - goPage(pageIndex, navKind)
   :param pageIndex: (int)
   :param navKind: (str) one of ('prev', 'next', 'index')
*/

export default {
  name: 'Paginate',
  components: {},

  props: {
    totalPages: { type: Number, required: true },
    currentPage: { type: Number, required: true },
  },

  data() {
    return {};
  },

  computed: {
    pages() {
      const result = [];
      let skipping = false;
      for (let i = 1; i <= this.totalPages; i++) {
        if (Math.abs(this.currentPage - i) < 3
            || i < 3
            || i > (this.totalPages - 2)) {
          skipping = false;
          result.push({ index: i });
        } else if (skipping === false) {
          skipping = true;
          result.push(0);
        }
      }
      return result;
    },
  },

  methods: {
    goPrev() {
      if (this.currentPage > 1) {
        this.$emit('goPage', this.currentPage - 1, 'prev');
      }
    },
    goNext() {
      if (this.currentPage < this.totalPages) {
        this.$emit('goPage', this.currentPage + 1, 'next');
      }
    },
  },
};
</script>

<style scoped>
</style>
